import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import axios from "../../api/axios";

const MyProfile = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.UserReducer);
  const profileUrl = "/user/me";

  const [profileServerData, setProfileServerData] = React.useState({});

  const getProfileDetails = () => {
    try {
      axios
        .get(profileUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.user) {
            setProfileServerData(response.data.user);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getProfileDetails();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-3xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <div className='shadow overflow-hidden sm:rounded-md'>
                  <div className='px-4 py-5 bg-white sm:p-6 shadow'>
                    <div className='mt-3 sm:mt-4 grid grid-cols-12 gap-6'>
                      <div className='col-span-12 grid justify-items-center'>
                        <div>
                          {profileServerData?._id ? (
                            <img
                              className='h-32 w-32 rounded-full ring-1 ring-yellow-2'
                              src={profileServerData?.avatar}
                              alt=''
                              referrerPolicy='no-referrer'
                            />
                          ) : (
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-32 bg-gray-300 h-32 rounded-full'></div>
                            </div>
                          )}
                        </div>
                      </div>
                      {profileServerData?._id ? (
                        <div className='col-span-12 text-center'>
                          <h2 className='text-2xl font-base leading-7 text-yellow-2 sm:text-3xl '>
                            {profileServerData.fullname}
                          </h2>
                          <h2 className='text-lg font-base leading-7 text-gray-dark '>
                            {profileServerData?.aclGroup
                              ?.slice(0, 1)
                              .toUpperCase()}
                            {profileServerData?.aclGroup?.slice(1)} (
                            {profileServerData?.departmentId?.name})
                          </h2>
                          <h2 className='text-xl py-5 font-base leading-7 text-gray-dark '>
                            Account currently{" "}
                            <strong>
                              {profileServerData?.accountStatus
                                ?.slice(0, 1)
                                .toUpperCase()}
                              {profileServerData?.accountStatus?.slice(1)}
                            </strong>{" "}
                            to access resources.
                          </h2>
                        </div>
                      ) : (
                        <div className='col-span-12'>
                          <div className='flex animate-pulse flex-col items-center h-full justify-center px-3'>
                            <div className='w-64 bg-yellow-2 h-8 rounded-md '></div>
                            <div className='w-72 bg-gray-100 h-6 rounded-md mt-3'></div>
                            <div className='w-full bg-gray-100 h-6 rounded-md mt-6'></div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </button>
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default MyProfile;
